export default {
    "name": "CourseLesson",
    "kind": "HoudiniQuery",
    "hash": "61af3a8c8f87304129b80b27e014c61859e248bef8b70c2bae10c3603453e29d",

    "raw": `query CourseLesson($courseSlug: String!) {
  course(where: {slug: $courseSlug}) {
    id
    name
    slug
    keyTakeaways
    outline
    shortDescription
    updatedAt
    thumbnail {
      url
      id
    }
    skillLevel
    timeToComplete
    lessons(first: 999) {
      id
      name
      slug
      videoUrl
      streamUrl
      description
      accessLevel
      furtherReading
    }
    instructors {
      name
      id
    }
    seo {
      metaTitle
      metaDescription
      ogTitle
      ogDescription
      ogImage {
        ...Image
        id
      }
      id
    }
    featuredThumbnail {
      ...Image
      id
    }
  }
}

fragment Image on Asset {
  url(transformation: {document: {output: {format: webp}}})
  sm: url(
    transformation: {image: {resize: {width: 320}}, document: {output: {format: webp}}}
  )
  md: url(
    transformation: {image: {resize: {width: 640}}, document: {output: {format: webp}}}
  )
  lg: url(
    transformation: {image: {resize: {width: 1024}}, document: {output: {format: webp}}}
  )
  xl: url(
    transformation: {image: {resize: {width: 1280}}, document: {output: {format: webp}}}
  )
  social: url(
    transformation: {image: {resize: {width: 1200, height: 630, fit: crop}}, document: {output: {format: png}}}
  )
  width
  id
  __typename
}
`,

    "rootType": "Query",

    "selection": {
        "fields": {
            "course": {
                "type": "Course",
                "keyRaw": "course(where: {slug: $courseSlug})",
                "nullable": true,

                "selection": {
                    "fields": {
                        "id": {
                            "type": "ID",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "name": {
                            "type": "String",
                            "keyRaw": "name",
                            "nullable": true,
                            "visible": true
                        },

                        "slug": {
                            "type": "String",
                            "keyRaw": "slug",
                            "nullable": true,
                            "visible": true
                        },

                        "keyTakeaways": {
                            "type": "String",
                            "keyRaw": "keyTakeaways",
                            "visible": true
                        },

                        "outline": {
                            "type": "String",
                            "keyRaw": "outline",
                            "nullable": true,
                            "visible": true
                        },

                        "shortDescription": {
                            "type": "String",
                            "keyRaw": "shortDescription",
                            "nullable": true,
                            "visible": true
                        },

                        "updatedAt": {
                            "type": "DateTime",
                            "keyRaw": "updatedAt",
                            "visible": true
                        },

                        "thumbnail": {
                            "type": "Asset",
                            "keyRaw": "thumbnail",

                            "selection": {
                                "fields": {
                                    "url": {
                                        "type": "String",
                                        "keyRaw": "url",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "skillLevel": {
                            "type": "SkillLevel",
                            "keyRaw": "skillLevel",
                            "nullable": true,
                            "visible": true
                        },

                        "timeToComplete": {
                            "type": "String",
                            "keyRaw": "timeToComplete",
                            "nullable": true,
                            "visible": true
                        },

                        "lessons": {
                            "type": "Lesson",
                            "keyRaw": "lessons(first: 999)",

                            "selection": {
                                "fields": {
                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "visible": true
                                    },

                                    "slug": {
                                        "type": "String",
                                        "keyRaw": "slug",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "videoUrl": {
                                        "type": "String",
                                        "keyRaw": "videoUrl",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "streamUrl": {
                                        "type": "String",
                                        "keyRaw": "streamUrl",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "description": {
                                        "type": "String",
                                        "keyRaw": "description",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "accessLevel": {
                                        "type": "AccessLevel",
                                        "keyRaw": "accessLevel",
                                        "visible": true
                                    },

                                    "furtherReading": {
                                        "type": "String",
                                        "keyRaw": "furtherReading",
                                        "nullable": true,
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "instructors": {
                            "type": "Instructor",
                            "keyRaw": "instructors",

                            "selection": {
                                "fields": {
                                    "name": {
                                        "type": "String",
                                        "keyRaw": "name",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "seo": {
                            "type": "Seo",
                            "keyRaw": "seo",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "metaTitle": {
                                        "type": "String",
                                        "keyRaw": "metaTitle",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "metaDescription": {
                                        "type": "String",
                                        "keyRaw": "metaDescription",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "ogTitle": {
                                        "type": "String",
                                        "keyRaw": "ogTitle",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "ogDescription": {
                                        "type": "String",
                                        "keyRaw": "ogDescription",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "ogImage": {
                                        "type": "Asset",
                                        "keyRaw": "ogImage",
                                        "nullable": true,

                                        "selection": {
                                            "fields": {
                                                "url": {
                                                    "type": "String",
                                                    "keyRaw": "url(transformation: {document: {output: {format: webp}}})",
                                                    "visible": true
                                                },

                                                "sm": {
                                                    "type": "String",
                                                    "keyRaw": "sm(transformation: {image: {resize: {width: 320}}, document: {output: {format: webp}}})",
                                                    "visible": true
                                                },

                                                "md": {
                                                    "type": "String",
                                                    "keyRaw": "md(transformation: {image: {resize: {width: 640}}, document: {output: {format: webp}}})",
                                                    "visible": true
                                                },

                                                "lg": {
                                                    "type": "String",
                                                    "keyRaw": "lg(transformation: {image: {resize: {width: 1024}}, document: {output: {format: webp}}})",
                                                    "visible": true
                                                },

                                                "xl": {
                                                    "type": "String",
                                                    "keyRaw": "xl(transformation: {image: {resize: {width: 1280}}, document: {output: {format: webp}}})",
                                                    "visible": true
                                                },

                                                "social": {
                                                    "type": "String",
                                                    "keyRaw": "social(transformation: {image: {resize: {width: 1200, height: 630, fit: crop}}, document: {output: {format: png}}})",
                                                    "visible": true
                                                },

                                                "width": {
                                                    "type": "Float",
                                                    "keyRaw": "width",
                                                    "nullable": true,
                                                    "visible": true
                                                },

                                                "id": {
                                                    "type": "ID",
                                                    "keyRaw": "id",
                                                    "visible": true
                                                },

                                                "__typename": {
                                                    "type": "String",
                                                    "keyRaw": "__typename",
                                                    "visible": true
                                                }
                                            },

                                            "fragments": {
                                                "Image": {
                                                    "arguments": {}
                                                }
                                            }
                                        },

                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        },

                        "featuredThumbnail": {
                            "type": "Asset",
                            "keyRaw": "featuredThumbnail",
                            "nullable": true,

                            "selection": {
                                "fields": {
                                    "url": {
                                        "type": "String",
                                        "keyRaw": "url(transformation: {document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "sm": {
                                        "type": "String",
                                        "keyRaw": "sm(transformation: {image: {resize: {width: 320}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "md": {
                                        "type": "String",
                                        "keyRaw": "md(transformation: {image: {resize: {width: 640}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "lg": {
                                        "type": "String",
                                        "keyRaw": "lg(transformation: {image: {resize: {width: 1024}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "xl": {
                                        "type": "String",
                                        "keyRaw": "xl(transformation: {image: {resize: {width: 1280}}, document: {output: {format: webp}}})",
                                        "visible": true
                                    },

                                    "social": {
                                        "type": "String",
                                        "keyRaw": "social(transformation: {image: {resize: {width: 1200, height: 630, fit: crop}}, document: {output: {format: png}}})",
                                        "visible": true
                                    },

                                    "width": {
                                        "type": "Float",
                                        "keyRaw": "width",
                                        "nullable": true,
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "ID",
                                        "keyRaw": "id",
                                        "visible": true
                                    },

                                    "__typename": {
                                        "type": "String",
                                        "keyRaw": "__typename",
                                        "visible": true
                                    }
                                },

                                "fragments": {
                                    "Image": {
                                        "arguments": {}
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {}
    },

    "input": {
        "fields": {
            "courseSlug": "String"
        },

        "types": {}
    },

    "policy": "CacheOrNetwork",
    "partial": false
};

"HoudiniHash=9213bfd766e2d2546ccb1ebfaa177d342edae0999e7a81335db2217edb1cabc6";